import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './TagInput.css';

export const DamNumberInput = (props) => {
  const [value, setValue] = useState(props.value || '');
  const [edit, setEdit] = useState(props.edit);
  const { t } = useTranslation();

  const onChange = (e) => {
    setValue(e.target.value);
  }

  const onClick = () => {
    setEdit(true);
    setValue(props.value || '');
  }

  if (!edit) {
    return (
      <div onClick={onClick} className="tag-input-display">
        <span className={props.value ? 'tag-input-label' : undefined}>{props.value ? `${t('tag_prefix')}-${props.value}` : '—'}</span>
        <span className="tag-input-edit-icon">&#10000;</span>
      </div>
    );
  }

  return (
    <input type="text" name="dam"
           placeholder={t(props.placeholderKey || 'dam_tag_number')}
           autoFocus={!props.edit}
           value={value}
           onChange={onChange}
           onBlur={props.onBlur}
    />
  );
}

export default DamNumberInput;
